import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { BusinessVerification } from './business-verification';

export class CreateBusinessVerificationDto extends Omit(BusinessVerification, BaseEntityFieldsArray) {}
